export default {

  /**
   * @param state
   * @returns {Array}
   */
  countries(state) {
    const countries = [];
    Object.keys(state.countries.items).forEach((id) => {
      countries.push(state.countries.items[id]);
    });
    return countries;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/getters.js